import { useCallback } from "react";
import useAjax from "@apis/useAjax";
import {
	GET_MEMBER_DISCARD_RECORD_OPTIONS,
	POST_MEMBER_DISCARD_RECORD_STOP_SMS
} from "@apis/apiPath";

const useMemberDiscardRecordApi = () => {
	const Ajax = useAjax();

	const getMemberDiscardRecordOptionsApi = useCallback(
		async () => {
			return await Ajax.get(GET_MEMBER_DISCARD_RECORD_OPTIONS);
		},
		// eslint-disable-next-line
		[]
	);

	const postMemberDiscardRecordStopSMSApi = useCallback(
		async (data) => {
			return await Ajax.post(POST_MEMBER_DISCARD_RECORD_STOP_SMS, data);
		},
		// eslint-disable-next-line
		[]
	);

	return {
		getMemberDiscardRecordOptionsApi,
		postMemberDiscardRecordStopSMSApi
	};
};

export default useMemberDiscardRecordApi;
